import type { DOMOutputSpec } from 'ricos-types';
import { createRicosNodeExtension } from 'wix-rich-content-plugin-commons';

export interface HardBreakOptions {
  keepMarks: boolean;

  HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    hardBreak: {
      /**
       * Add a hard break
       */
      setHardBreak: () => ReturnType;
    };
  }
}

export const hardBreak = createRicosNodeExtension<{
  HTMLAttributes: Record<string, string>;
  keepMarks: boolean;
}>({
  name: 'hardBreak',
  groups: [],
  type: 'html-node',
  createExtensionConfig({ mergeAttributes }) {
    return {
      name: this.name,
      inline: true,
      group: 'inline',
      priority: 900,

      selectable: false,

      parseHTML() {
        return [{ tag: 'br' }];
      },

      renderHTML({ HTMLAttributes }) {
        return [
          'br',
          mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
        ] as DOMOutputSpec;
      },

      renderText() {
        return '\n';
      },
      addCommands() {
        return {
          setHardBreak:
            () =>
            ({ commands, chain, state, editor }) => {
              return commands.first([
                () => commands.exitCode(),
                () =>
                  commands.command(() => {
                    const { selection, storedMarks } = state;

                    if (selection.$from.parent.type.spec.isolating) {
                      return false;
                    }

                    const { keepMarks } = this.options;
                    const { splittableMarks } = editor.extensionManager;
                    const marks =
                      storedMarks || (selection.$to.parentOffset && selection.$from.marks());

                    return chain()
                      .insertContent({ type: this.name })
                      .command(({ tr, dispatch }) => {
                        if (dispatch && marks && keepMarks) {
                          const filteredMarks = marks.filter(mark =>
                            splittableMarks.includes(mark.type.name)
                          );

                          tr.ensureMarks(filteredMarks);
                        }

                        return true;
                      })
                      .run();
                  }),
              ]);
            },
        };
      },
    };
  },
});
